import { FC, Suspense } from "react";
import ErrorBoundary from "./ErrorBoundary";
import LoadingFallback from "./LoadingFallback";

interface RouteWrapperProps {
  children: React.ReactNode;
  loadingMessage?: string;
}

const RouteWrapper: FC<RouteWrapperProps> = ({
  children,
  loadingMessage = "Loading...",
}) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback message={loadingMessage} />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};

export default RouteWrapper;
